import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import {
  Button,
  CircularProgress,
  Container,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { GenericDrawer } from 'app/components/GenericDrawer/GenericDrawer';

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

import styles from './styles';
import moment from 'moment';
import SurveyForm from 'app/components/SurveyForm';
import helpers from 'app/utils/helpers';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import { VEHICLE_REPORT_SITUATION } from 'app/utils/constants';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { clearFiles } from 'app/store/slices/forms';
import { searchCompanyNameAndDocument } from 'app/store/slices/company';
const useStyles = makeStyles(styles);

const SurveyData = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedSurveyVehicle, setSelectedSurveyVehicle] = useState({});

  const { request, survey, handleSelectSurvey } = props;

  const [document, setDocument] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      if (request?.jsonSolicitacao) {
        const jsonSolicitacao = JSON.parse(request.jsonSolicitacao);
        let tempDocument = jsonSolicitacao.cdTipoPessoaFisica
          ? jsonSolicitacao.deCpf || ''
          : jsonSolicitacao.deCnpjMatriz || jsonSolicitacao.deCpfCnpj || '';
        let tempName = jsonSolicitacao.cdTipoPessoaFisica
          ? jsonSolicitacao.nmCompleto || ''
          : jsonSolicitacao.deRazaoSocial ||
            jsonSolicitacao.nmCompleto ||
            jsonSolicitacao.nmUsuario ||
            '';

        if (tempDocument === '' || tempName === '') {
          const companyInfo = await searchCompanyNameAndDocument(request.cdSolicitacao);
          tempName = companyInfo.name;
          tempDocument = companyInfo.document;
        }

        setDocument(tempDocument);
        setName(tempName);
      }

      const tempRows = survey.vistoriaVeiculos || [];
      setRows(tempRows);
      setLoading(false);
    };
    init();
  }, [request, survey]);

  const onCloseDrawer = () => {
    setSelectedSurveyVehicle({});
    setOpenDrawer(false);
  };

  const onOpenDrawer = row => {
    setSelectedSurveyVehicle(row);
    setOpenDrawer(true);
  };

  const [rows, setRows] = useState([]);

  const handleOnSave = async values => {
    try {
      // let error = false;
      // if (!values.documentos || values.documentos.length === 0) {
      //   error = true;
      // }
      // if (error) {
      //   notification(
      //     intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_REPORT_REQUIRED' }),
      //     {
      //       toastId: 'DOCUMENT_REPORT_REQUIRED',
      //       type: 'warning',
      //     }
      //   );
      //   return false;
      // }
      const response = await surveyEndpoint.saveVehicleSurvey(request.cdSolicitacao, values);
      if (response.status === 200 && response.data) {
        dispatch(clearFiles());
        if (handleSelectSurvey) {
          handleSelectSurvey(request);
        }
        onCloseDrawer();
      }
    } catch (error) {}
  };

  return (
    <>
      <GenericDrawer
        open={openDrawer}
        title="Registro de laudo de inspeção de veículo"
        onClose={() => onCloseDrawer()}
      >
        <Container>
          <SurveyForm
            {...props}
            open={openDrawer}
            classes={classes}
            surveyVehicle={selectedSurveyVehicle}
            onSave={values => handleOnSave(values)}
            onCancel={() => onCloseDrawer()}
          />
        </Container>
      </GenericDrawer>

      {loading && (
        <div className={classes.centerProgress}>
          <CircularProgress size={20} />
        </div>
      )}
      {!loading && (
        <>
          <Grid container spacing={1} className={classes.requestInfo}>
            <Grid item xs={12} sm={6}>
              <b>Solicitação {request.nuSolicitacaoFmt}</b>
            </Grid>
            <Grid item xs={12} sm={6}>
              Empresa/Nome : {name}
            </Grid>
            <Grid item xs={12} sm={6}>
              Data solicitação:{' '}
              {request.dtCadastro ? moment.utc(request.dtCadastro).format('DD/MM/YYYY') : '-'}
            </Grid>
            <Grid item xs={12} sm={6}>
              CNPJ/CPF: {helpers.formatarDocumento(document)}
            </Grid>
          </Grid>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.headTableCell} align="center">
                  Placa
                </TableCell>
                <TableCell className={classes.headTableCell} align="left">
                  Renavam
                </TableCell>
                <TableCell className={classes.headTableCell} align="left">
                  Data vistoria
                </TableCell>
                <TableCell className={classes.headTableCell} align="left">
                  Horário da vistoria
                </TableCell>
                <TableCell className={classes.headTableCell} align="left">
                  Situação da vistoria
                </TableCell>
                <TableCell className={classes.headTableCell} align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                let situation = '-';
                if (row.tpSituacao) {
                  const found = _.find(VEHICLE_REPORT_SITUATION, ['sg', row.tpSituacao]);
                  situation = found.description.toUpperCase();
                }
                return (
                  <TableRow key={`v-${index}`} className={classes.tableRow}>
                    <TableCell align="center" component="th" scope="row">
                      {row.veiculo?.dePlaca || '-'}
                    </TableCell>
                    <TableCell align="left">{row.veiculo?.deRenavam || '-'}</TableCell>
                    <TableCell align="left">
                      {row.dtVistoria ? moment.utc(row.dtVistoria).format('DD/MM/YYYY') : '-'}
                    </TableCell>
                    <TableCell align="left">{row.hrVistoria || '-'}</TableCell>
                    <TableCell
                      align="left"
                      className={
                        row.tpSituacao === VEHICLE_REPORT_SITUATION.APROVADO.sg
                          ? classes.approved
                          : classes.disapproved
                      }
                    >
                      {situation}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        color="primary"
                        className={classes.btnSigleAction}
                        size="small"
                        onClick={() => onOpenDrawer(row)}
                      >
                        <PlaylistAddCheckIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      )}
    </>
  );
};

export default injectIntl(SurveyData);
